import { createStore, applyMiddleware } from 'redux';
import fetchMiddleware from '../middleware/fetchMiddlleware';
import reducers from './index';
import formData from '../Modules/formData';
import Cookies from 'js-cookie';
import { carouselMode, defaultValues, propertyType } from '../Enums';
import apiState from '../apiState';

const getReduxStore = (data) => {
    const serverData = data['translationsData'];
    const userData = data['userData'];
    let middleware = [fetchMiddleware];
    return createStore(reducers, {
            translationsReducer: {
                ...serverData
            },
            userDetailsReducer: {
                ...userData
            },
            globalReducer: {
                ...serverData,
                formData: {
                    ...formData,
                    full_name: Cookies.get('name')
                        ? Cookies.get('name')
                        : formData['full_name'],
                    mobile_number: Cookies.get('phone')
                        ? Cookies.get('phone')
                        : formData['mobile_number'],
                    email_address: Cookies.get('email')
                        ? Cookies.get('email')
                        : formData['email_address']
                },
                type_of_property: propertyType.HOTEL,
                number_of_rooms: defaultValues.number_of_rooms,
                estimated_revenue:null,
                location: '',
                scroll_steps_to_partner: false,
                scroll_programs: false,
                are_you_a_seller: false,
                header_height: '',
                selected_location: {},
                carousel_mode: carouselMode.HOTEL,
                hms_self_onboarding_enabled: data['hms_self_onboarding_enabled'],
                ...apiState
            }
        },
        applyMiddleware(...middleware));
};

export default getReduxStore;
